export const init = () => {
  if (document.querySelector('.js-product-section')) {
    const section = document.querySelectorAll('.js-product-section');
    section.forEach((item) => {
      if (item.querySelector('.js-show-items')) {
        const loadMore = item.querySelector('.js-show-items');
        const hiddenItems = item.querySelector('.js-hidden-items');
        loadMore.addEventListener('click', () => {
          loadMore.classList.toggle('active');
          hiddenItems.classList.toggle('active');
          if (hiddenItems.classList.contains('active')) {
            loadMore.querySelector('.js-button-text').innerHTML = loadMore.querySelector('.js-button-text').dataset.labelLess;
          }
          else {
            loadMore.querySelector('.js-button-text').innerHTML = loadMore.querySelector('.js-button-text').dataset.labelMore;
          }
        })
        const hiddenItemsIDs = hiddenItems.querySelectorAll('.content__item');
        hiddenItemsIDs.forEach((item) => {
          const urlID = window.location.hash;
          if (urlID == `#${item.id}`) {
            hiddenItems.classList.add('active');
            loadMore.classList.add('active');
          }
          else {
            console.log(urlID);
          }
        })
      }
    });
  }
}